import { loadStripe, Stripe } from '@stripe/stripe-js';
import { trackStripeLoadFailed } from './analytics/funnelV3Analytics';

const MAX_ATTEMPTS = 3;
const BACKOFF_MS = [400, 1200];

let cachedPromise: Promise<Stripe | null> | null = null;

function sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

async function loadWithRetry(publishableKey: string): Promise<Stripe | null> {
    let lastError: unknown = null;
    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
        try {
            const instance = await loadStripe(publishableKey);
            if (instance !== null) return instance;
            lastError = new Error('loadStripe resolved to null');
        } catch (err) {
            lastError = err;
        }
        const errorMessage =
            lastError instanceof Error ? lastError.message : String(lastError);
        trackStripeLoadFailed(attempt, MAX_ATTEMPTS, errorMessage);
        if (attempt < MAX_ATTEMPTS) {
            await sleep(BACKOFF_MS[attempt - 1]);
        }
    }
    throw lastError instanceof Error
        ? lastError
        : new Error(String(lastError));
}

export function loadStripeWithRetry(
    publishableKey: string,
): Promise<Stripe | null> {
    if (!cachedPromise) {
        cachedPromise = loadWithRetry(publishableKey);
    }
    return cachedPromise;
}

export function resetStripeLoader(): void {
    cachedPromise = null;
}
